import axios from 'axios';

export async function getQuotes(token: string, params: { skip: number; take: number }) {
   try {
      const response = await axios.get(process.env.REACT_APP_BASE_URL+`/cotacoes/usuario`, {
        params,
        headers: {
            Authorization: 'Bearer ' + token
        }
        });
  
      return response.data; // Supondo que as requisições sejam retornados pelo backend
    } catch (error) {
      throw new Error('Falha na autenticação');
    }
}
